import React from 'react';
import { Card, Layout, Tabs } from 'antd';
import LoginFormPassword from '@/components/login/LoginFormPassword';
import shop_bg from '@/components/login/img/shop_bg.png';
import styles from '@/components/login/login.module.less';
import shop_title from '@/components/login/img/shop_title.png';
import MallType from '@/const/MallType';

function LoginOnlineMall() {
  return (
    <Layout className={styles.layoutWrap}>
      <Layout.Content className={styles.content}>
        <div className={styles.loginWrap}>
          <Card
            width={1200}
            className={styles.contentCard}
            bordered={false}
            bodyStyle={{ padding: 0 }}
          >
            <div style={{ position: 'absolute', top: '26px', left: '40px', zIndex: 1 }}>
              <img alt="pic" src={shop_bg} className={styles.centerPic} />
            </div>
            <div className={styles.right}>
              <div className={styles.rightTitle}>
                <img alt="logo" src={shop_title} />
              </div>
              <div className={styles.rightContent}>
                <Tabs defaultActiveKey="1">
                  <Tabs.TabPane tab="货物类网上商城" key="1">
                    <LoginFormPassword mallType={MallType.Goods} />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="服务类网上商城" key="2">
                    <LoginFormPassword mallType={MallType.SERVER} />
                  </Tabs.TabPane>
                </Tabs>
              </div>
            </div>
          </Card>
          {/*<LoginAnnouncement />*/}
        </div>
      </Layout.Content>
    </Layout>
  );
}

export default LoginOnlineMall;
